<app-page-shell [breadcrumb]="breadcrumb">
  <header class="mx-auto max-w-4xl pt-16 text-center md:pt-24">
    <p class="eyebrow">{{ 'pages.aboutUs.hero.eyebrow' | transloco }}</p>
    <h1 class="mt-4 font-display text-4xl font-bold leading-[1.05] text-ink md:text-6xl">
      {{ 'pages.aboutUs.hero.titlePrefix' | transloco }}
      <em class="not-italic text-primary">{{ 'pages.aboutUs.hero.titleAccent' | transloco }}</em>
    </h1>
    <p class="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
      {{ 'pages.aboutUs.hero.description' | transloco }}
    </p>
  </header>

  <section class="mx-auto mt-14 max-w-5xl">
    <div class="space-y-5 text-justify text-base leading-relaxed text-foreground md:text-[17px]">
      <p>
        <span
          class="float-left mr-3 mt-1 font-display text-[56px] font-semibold leading-[0.85] text-primary md:mr-4 md:text-[72px]"
          aria-hidden="true"
        >
          A
        </span>
        <span class="font-semibold text-foreground">
          {{ 'pages.aboutUs.manifesto.organization' | transloco }}
        </span>
        {{ 'pages.aboutUs.manifesto.paragraph1Part1' | transloco }}
        <em class="not-italic font-semibold">
          {{ 'pages.aboutUs.manifesto.emphasis' | transloco }}
        </em>
        {{ 'pages.aboutUs.manifesto.paragraph1Part2' | transloco }}
      </p>
      <p>
        {{ 'pages.aboutUs.manifesto.paragraph2Part1' | transloco }}
        <em class="not-italic font-semibold">
          {{ 'pages.aboutUs.manifesto.trust' | transloco }}
        </em>.
      </p>
    </div>

    <p class="mt-8">
      <a
        [routerLink]="'/servicos' | localizedRouterLink"
        class="group inline-flex items-center gap-2 text-base font-semibold text-primary transition-colors hover:text-secondary"
      >
        {{ 'pages.aboutUs.manifesto.servicesCta' | transloco }}
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="h-4 w-4 transition-transform group-hover:translate-x-0.5"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </a>
    </p>
  </section>

  <section id="equipe" class="mx-auto mt-20 max-w-5xl">
    <p class="eyebrow">{{ 'pages.aboutUs.team.eyebrow' | transloco }}</p>
    <h2 class="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground md:text-3xl">
      {{ 'pages.aboutUs.team.title' | transloco }}
    </h2>
    <p class="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-[17px]">
      {{ 'pages.aboutUs.team.description' | transloco }}
    </p>

    <div class="mt-10 border-b border-border">
      @for (area of teamAreas; track area.id) {
        <section
          class="grid grid-cols-1 gap-x-10 gap-y-3 border-t border-border py-5 md:grid-cols-[260px_1fr] md:py-6"
        >
          <header class="flex flex-col gap-2">
            <h3 class="font-display text-lg font-semibold leading-tight tracking-[-0.015em] text-foreground md:text-xl">
              {{ area.titleKey | transloco }}
            </h3>
            <p class="text-[14px] leading-relaxed text-muted-foreground">
              {{ area.descriptionKey | transloco }}
            </p>
          </header>

          <ul class="flex flex-wrap items-center gap-x-1.5 gap-y-2 text-[15px] leading-snug">
            @for (person of area.people; track person.name; let last = $last) {
              <li class="inline-flex items-center gap-1.5">
                @if (person.linkedin) {
                  <a
                    [href]="person.linkedin"
                    target="_blank"
                    rel="noreferrer"
                    [attr.aria-label]="'pages.aboutUs.team.linkedinAriaLabel' | transloco: { name: person.name }"
                    class="rounded font-medium text-primary transition-colors hover:text-secondary"
                  >
                    {{ person.name }}
                  </a>
                } @else {
                  <span class="font-medium text-primary">
                    {{ person.name }}
                  </span>
                }

                @if (!last) {
                  <span class="text-foreground/25" aria-hidden="true">·</span>
                }
              </li>
            }
          </ul>
        </section>
      }
    </div>
  </section>
</app-page-shell>
